import { assign, createMachine, interpret } from "xstate";
import apiMethods from "../api/apiMethods";
import { apiRole } from "../api/apiRole";

/*
 * В этой машине хранится состояние авторизации.
 * При первом открытии страницы выполняется проверка:
 * 1. Есть ли в локальном хранилище токен
 * 2. Если токен есть, посылается запрос "/api/init", который проверяет, действителен ли он
 */
const authMachine = createMachine(
	{
		id: "authorization",
		context: {
			type: undefined,
			subtype: undefined,
			is_personal_data_storage_allowed: undefined,
			// is_verify_dist: true,
			// is_new_order: 2,
			has_not_verified_service_orders: undefined,
			registration_document_type_status: undefined,
			service_order_verification_status: "",
			user_identities_status: "",
			max_prize_price_without_identities: 0,
			name: "",
			id: "",
			email: "",
			surname: "",
			balance: 0,
			avatar: "",
			can_upload: undefined,
			errorMsg: "",
		},
		initial: "idle",
		states: {
			idle: {
				invoke: {
					src: "check",
					id: "check",
					onDone: {
						target: "auth",
					},
					onError: {
						target: "unAuth",
					},
				},
			},
			unAuth: {
				invoke: {
					id: "clearToken",
					src: "clearToken",
				},
				on: {
					login: {
						target: "loading",
					},
					done: {
						actions: ["reset"],
					},
				},
			},
			loading: {
				invoke: {
					id: "authentication",
					src: "authentication",
				},
				on: {
					success: {
						target: "auth",
					},
					error: {
						target: "unAuth",
						actions: ["saveError"],
					},
				},
			},
			auth: {
				initial: "noData",
				states: {
					noData: {
						invoke: {
							src: "getUserData",
							id: "getUserData",
						},
						on: {
							done: {
								target: "getDataUser",
								actions: ["saveUserData", "clearError"],
							},
							error: {
								target: "error",
								actions: ["saveError"],
							},
						},
					},
					error: {
						target: "unAuth",
						actions: ["saveError"],
					},
					getDataUser: {
						on: {
							allowPersonalData: {
								target: "updatingPersonalData",
							},
						},
					},
					updatingPersonalData: {
						invoke: {
							src: "sendAllowPersonalData",
							onDone: {
								target: "noData",
								actions: assign({
									is_personal_data_storage_allowed: true,
								}),
							},
							onError: {
								target: "noData",
								actions: ["saveError"],
							},
						},
					},
				},
				on: {
					logout: {
						target: "unAuth",
					},
					updateServiceOrderVerificationStatus: {
						actions: ["updateVerificationStatus"],
					},
				},
			},
		},
	},
	{
		actions: {
			updateVerificationStatus: assign({
				service_order_verification_status: (ctx, message) =>
					message.data?.service_order_verification_status ||
					ctx.service_order_verification_status,
			}),
			saveUserData: assign(
				{
					type: (ctx, message) => message.data.type,
					subtype: (ctx, message) => message.data.subtype,
					is_personal_data_storage_allowed: (ctx, message) =>
						message.data.is_personal_data_storage_allowed,
					service_order_verification_status: (ctx, message) =>
						message.data.service_order_verification_status,
					has_not_verified_service_orders: (ctx, message) =>
						message.data.has_not_verified_service_orders,
					registration_document_type_status: (ctx, message) =>
						message.data.registration_document_type_status,
					user_identities_status: (ctx, message) =>
						message.data.user_identities_status,
					max_prize_price_without_identities: (ctx, message) =>
						message.data.max_prize_price_without_identities,
					name: (ctx, message) => message.data.name,
					email: (ctx, message) => message.data.email,
					id: (ctx, message) => message.data.id,
					balance: (ctx, message) => message.data.balance,
					surname: (ctx, message) => message.data.surname,
					avatar: (ctx, message) => message.data.avatar,
					can_upload: (ctx, message) => message.data.can_upload,
				},
				(ctx, message) => {
					// Вернуть обновленный контекст
					return { ...ctx, ...message.data };
				},
			),
			saveError: assign({
				errorMsg: (ctx, message) => message.data,
			}),
			reset: assign({
				type: undefined,
				subtype: undefined,
				is_personal_data_storage_allowed: undefined,
				has_not_verified_service_orders: undefined,
				registration_document_type_status: undefined,
				service_order_verification_status: "",
				name: "",
				id: "",
				email: "",
				balance: 0,
				user_identities_status: "",
				max_prize_price_without_identities: 0,
				surname: "",
				avatar: "",
				can_upload: undefined,
				errorMsg: "",
			}),
			clearError: assign({
				errorMsg: "",
			}),
		},
		services: {
			sendAllowPersonalData: () => {
				return async function (send) {
					try {
						const response =
							await apiMethods.authentication.allowPersonalDataStorage();
						if (response.status === 200) {
							send({ type: "done" });
						}
					} catch (error) {
						send({ type: "error", data: error });
					}
				};
			},
			check: () => {
				const token = localStorage.getItem("sessionID");
				if (token) {
					return (async () => {
						const response = await apiMethods.authentication.user();
						response.status === 401
							? Promise.reject("Unauthorized")
							: Promise.resolve();
					})();
				}
				return Promise.reject();
			},
			authentication: (ctx, message) =>
				async function (send) {
					await apiMethods.authentication
						.auth(message.data)
						.then(response => {
							if (response.status === 200) {
								console.log(message.data);
								localStorage.setItem("sessionID", response.data.access.token);
								send({
									type: "success",
								});
							}
						})
						.catch(response => {
							console.log("error => ", response.response.data.message);

							send({
								type: "error",
								data: response.response.data.message,
							});
						});
				},
			clearToken: async send => {
				const token = localStorage.getItem("sessionID");

				try {
					if (token) {
						await apiMethods.authentication.logout();
						send({
							type: "done",
						});
					}
				} catch (e) {
					console.log("err => ", e);
				}

				if (token) {
					localStorage.removeItem("sessionID");
					localStorage.removeItem("redirectSeller");
				}
			},
			getUserData: () => {
				const token = localStorage.getItem("sessionID");
				if (token) {
					return async function (send) {
						try {
							const response = await apiMethods.authentication.user();
							console.log("getUserData:", response.data);
							if (response.status === 200) {
								apiRole.isDedicatedDistributor =
									response.data.data?.subtype === "dedicated_distributor";
								send({
									type: "done",
									data: response.data.data,
								});
							}
						} catch (error) {
							send({
								type: "error",
								data: error,
							});
						}
					};
				}
			},
		},
	},
);

export const AuthState = interpret(authMachine, { devTools: true }).start();

export const waitForUserData = () =>
	new Promise(resolve => {
		if (AuthState.getSnapshot().context.type) {
			return resolve();
		}
		const subscription = AuthState.subscribe(state => {
			if (state.context.type) {
				subscription.unsubscribe();
				resolve();
			}
		});
	});
